import { useEffect } from "react";
import { useStoreInfo } from "../../context/StoreInfoContext";

const DynamicHead = () => {
  const { storeInfo } = useStoreInfo();

  useEffect(() => {
    if (!storeInfo) return;

    // Get favicon URL from API (prefer favicon_url, fallback to company_logo)
    const faviconUrl =
      storeInfo.theme?.settings?.favicon_url ||
      storeInfo.theme?.settings?.company_logo;

    // Get company name for title from API (prefer company_name, fallback to store_name)
    const companyName =
      storeInfo.theme?.settings?.meta_title ||
      storeInfo?.store?.store_name ||
      "Store";

    // Update favicon with multiple sizes
    const updateFavicon = (href) => {
      if (!href) return;

      // Remove existing favicon links
      const existingLinks = document.querySelectorAll("link[rel*='icon']");
      existingLinks.forEach((link) => link.remove());

      // Add new favicon link
      const link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png"; // You can make this dynamic based on file extension
      link.href = href;
      document.head.appendChild(link);

      // Add apple touch icon for iOS devices
      const appleTouchIcon = document.createElement("link");
      appleTouchIcon.rel = "apple-touch-icon";
      appleTouchIcon.href = href;
      document.head.appendChild(appleTouchIcon);
    };

    // Update document title
    const updateTitle = (title) => {
      if (title) {
        document.title = title;
      }
    };

    // Update meta description
    const updateMetaDescription = (description) => {
      let meta = document.querySelector("meta[name='description']");
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    };

    // Update additional meta tags
    const updateMetaTags = (companyName) => {
      // Update or create og:title
      let ogTitle = document.querySelector("meta[property='og:title']");
      if (!ogTitle) {
        ogTitle = document.createElement("meta");
        ogTitle.setAttribute("property", "og:title");
        document.head.appendChild(ogTitle);
      }
      ogTitle.content = companyName;

      // Update or create og:description
      let ogDescription = document.querySelector(
        "meta[property='og:description']"
      );
      if (!ogDescription) {
        ogDescription = document.createElement("meta");
        ogDescription.setAttribute("property", "og:description");
        document.head.appendChild(ogDescription);
      }
      ogDescription.content = description;

      // Update or create og:image
      if (faviconUrl) {
        let ogImage = document.querySelector("meta[property='og:image']");
        if (!ogImage) {
          ogImage = document.createElement("meta");
          ogImage.setAttribute("property", "og:image");
          document.head.appendChild(ogImage);
        }
        ogImage.content = faviconUrl;
      }
    };

    // Set favicon from company logo
    if (faviconUrl) {
      updateFavicon(faviconUrl);
    }

    // Set title
    updateTitle(companyName);

    // Set meta description
    const description =
      storeInfo.theme?.settings?.meta_description ||
      `Shop at ${companyName} - Your trusted online shopping destination.`;
    updateMetaDescription(description);

    // Update additional meta tags for social sharing
    updateMetaTags(companyName);
  }, [storeInfo]);

  return null; // This component doesn't render anything
};

export default DynamicHead;
